module.exports = __webpack_public_path__ + "img/sparks-02.eb734635.png";